<script lang="ts" setup>
import type { VForm } from "vuetify/components/VForm";
import { FormConfig, FormValues } from "./types";
const props = defineProps<{
  config: FormConfig;
  modelValue: any;
  loading?: boolean;
  disabled?: boolean;
}>();

const emit = defineEmits<{
  (e: "update:modelValue", value: any): void;
}>();

const form = ref<VForm>();
const value = computed({
  get: () => props.modelValue,
  set: (value: any) => emit("update:modelValue", value),
});

// Filter conditional fields
const conditionalSections = computed(() => {
  return props.config.sections.filter((section) => {
    if (section.conditional) {
      // Assess the conditional field
      return section.conditional(value.value);
    }
    return true;
  });
});
</script>

<template>
  <VForm ref="form" lazy-validation>
    <VRow v-if="config.title">
      <VCol cols="12">
        <h2>{{ $t(config.title) }}</h2>
      </VCol>
    </VRow>

    <VRow>
      <VCol
        v-for="section in conditionalSections"
        :cols="section.size?.xs ?? 12"
        :sm="section.size?.sm"
        :md="section.size?.md"
        :lg="section.size?.lg"
        :xl="section.size?.xl"
      >
        <FormSection
          :loading="loading"
          :disabled="disabled"
          :section="section"
          v-model="value"
        />
      </VCol>
    </VRow>
  </VForm>
</template>
